import { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { ColorPickerColors } from '../../../../models/ColorPicker';
import ColorPicker from '../../../Pickers/ColorPicker/ColorPicker';

interface ButtonColorPickerProps {
  value?: ColorPickerColors;
  colorPickerLabel?: string;
  onChangeColor?: (value: string) => void;
}

const ButtonColorPicker = ({ value, colorPickerLabel = 'Background color', onChangeColor }: ButtonColorPickerProps) => {
  useEffect(() => {
    if (String(value) === 'default') {
      onChangeColor('#2664b1');
    }
  }, [value, onChangeColor]);

  return (
    <Grid container alignItems="center" justifyContent="center" spacing={2}>
      <Grid sx={{ width: '80px' }} item>
        <Typography variant="caption" className="text-bold" color="#495057">
          {colorPickerLabel}
        </Typography>
      </Grid>
      <Grid item>
        <ColorPicker value={value} onPickColor={onChangeColor} />
      </Grid>
    </Grid>
  );
};

export default ButtonColorPicker;
